import React, { Component } from 'react';
import { translate } from 'react-i18next';

class PromoCodeContainer extends Component {

    render = () => {
        return (
            <React.Fragment>
                <img
                    src={`https://api.iosoffices.com/apiosfera/v4/src/uploads/cowork_imagenes/19`}
                    alt="Fondo de la imagen"
                    className="background-img"
                />
                <div className="flex-center page-info-container">
                    <div className="page-info-title">
                        <h2>IOS Network Summit</h2>
                        <h3>Auditorio Torre Reforma</h3>
                    </div>
                    <div className="page-info-container">
                        <p className="page-info-adress">
                            Av. P.º de la Reforma 483, Cuauhtémoc, 06500 Ciudad de México, CDMX
                        </p>
                        <div className="page-info-date">
                            <p style={{ color: "#FCFDFD" }}>
                                05 de Noviembre de 2025
                            </p>
                        </div>
                        {
                            // Se muestra promocode solo si se aplicó un descuento
                            this.props.porcentaje_summit && (
                                <div className="form-group page-info-promocode">
                                    <h4 style={{color: 'var(--accent-alt)'}}>Código Aplicado</h4>
                                    <input
                                        className="form-control"
                                        maxLength="16"
                                        onChange={this.props.handleChangePromocode}
                                        type="text"
                                        placeholder="Código promocional"
                                        disabled
                                        value={this.props.promoCode} />
                                </div>
                            )
                        }
                    </div>
                    <div className="page-info-buttom">
                        <div className="page-info-pay">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Subtotal:</td>
                                        <td style={{ textAlign: "right" }}>1499 MXN</td>
                                    </tr>
                                    {this.props.porcentaje_summit
                                        ? (
                                            <tr>
                                                <td>Porcentaje de Descuento:  </td>
                                                <td style={{ textAlign: "right" }}>{this.props.porcentaje_summit}%</td>
                                            </tr>
                                        )
                                        : null
                                    }
                                    {this.props.porcentaje_summit
                                        ? (
                                            <tr>
                                                <td>Descuento: </td>
                                                <td style={{ textAlign: "right" }}>{((this.props.porcentaje_summit / 100) * 1499).toFixed(2)}MXN</td>
                                            </tr>
                                        )
                                        : null
                                    }
                                    {this.props.porcentaje_summit
                                        ? (
                                            <tr>
                                                <td>Total: </td>
                                                <td style={{ textAlign: "right" }}>{((1 - (this.props.porcentaje_summit / 100)) * 1499).toFixed(2)}MXN</td>
                                            </tr>
                                        )
                                        : (
                                            <tr>
                                                <td>Total: </td>
                                                <td style={{ textAlign: "right" }}>1499 MXN</td>
                                            </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default translate('common')(PromoCodeContainer);


// WEBPACK FOOTER //
// ./src/guest/summit/PromoCodeContainer.js